import React, { useState } from "react";

import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";

import MarkdownDisplay from "../../../components/markdown/markdown-display.component";

export default function MarkdownTester(props) {
  const [data, setData] = useState(props.content);

  return (
    <div
      className="p-3"
      style={{ borderRadius: "12px", backgroundColor: "#f0f0f0" }}
    >
      <Row>
        <Col sm={6} md={6} lg={6}>
          <MarkdownDisplay content={data} />
        </Col>
        <Col>
          <Form.Control
            as="textarea"
            rows={8}
            value={data}
            onChange={(x) => setData(x.target.value)}
          />
        </Col>
      </Row>
    </div>
  );
}
